const SETTING_TYPES = {
  GRAPHIC: 'graphic',
  NUMBER: 'number',
  TEXT: 'text',
  COLOR: 'color',
  FONT: 'font',
  BOOLEAN: 'boolean',
} as const

export const presentationOptionsDefaults = {
  logo: {
    filename: 'sitelogo.png',
    value: '',
    name: 'Logo',
    key: 'logo',
    type: SETTING_TYPES.GRAPHIC,
  },
  backgroundImage: {
    filename: 'theme-background-image.png',
    value: '',
    name: 'Background image',
    key: 'background-image',
    type: SETTING_TYPES.GRAPHIC,
  },
  logoSize: {
    value: 200,
    name: 'Logo size',
    key: 'logo-size',
    type: SETTING_TYPES.NUMBER,
  },
  logoPosition: {
    value: 'left',
    name: 'Logo position',
    key: 'logo-position',
    type: SETTING_TYPES.TEXT,
  },
  brandPrimary: {
    value: '#1FC95B',
    name: 'Player button color',
    key: 'brand-primary',
    type: SETTING_TYPES.COLOR,
  },
  backgroundColor: {
    value: '#FFFFFF',
    name: 'Background color',
    key: 'background-color',
    type: SETTING_TYPES.COLOR,
  },
  headlineFont: {
    value: 'Open Sans',
    name: 'Headline font',
    key: 'headline-font',
    type: SETTING_TYPES.FONT,
  },
  headlineFontSize: {
    value: 32,
    name: 'Headline text size',
    key: 'headline-font-size',
    type: SETTING_TYPES.NUMBER,
  },
  bodyFont: {
    value: 'Open Sans',
    name: 'Body font',
    key: 'body-font',
    type: SETTING_TYPES.FONT,
  },
  bodyFontSize: {
    value: 16,
    name: 'Body text size',
    key: 'body-font-size',
    type: SETTING_TYPES.NUMBER,
  },
  personalPromoBanner: {
    value: true,
    name: 'Personal promo banner',
    key: 'personal-promo-banner',
    type: SETTING_TYPES.BOOLEAN,
  },
} as const
